export const PRICE_CHANGES_FETCH = '[Price] Changes Fetch'
export const PRICE_CHANGES_FETCH_SUCCESS = '[Prices] Changes Fetch Success'
export const fetchPriceChanges = () => ({ type: PRICE_CHANGES_FETCH })

export const PRICE_CHANGE_FETCH = '[Price] Change Fetch'
export const PRICE_CHANGE_FETCH_SUCCESS = '[Prices] Change Fetch Success'
export const fetchPriceChange = () => ({ type: PRICE_CHANGE_FETCH })